"use client";

import { Container, Stack, StackProps } from "@mui/material";
import { FC } from "react";
import { ContainerSize } from "src/lib/utils/types";
import SalifyComponent from "../salify-component/default";

interface SalifyStackWrapperProps {
  containerSize?: ContainerSize | undefined;
  direction?: "row" | "row-reverse" | "column" | "column-reverse" | undefined;
  stackProps?: StackProps;
  components: any[];
}

const SalifyStackWrapper: FC<SalifyStackWrapperProps> = (props) => {
  return props.containerSize === "full" || !props.containerSize ? (
    <StackWrapperContent {...props} />
  ) : (
    <Container maxWidth={props.containerSize} disableGutters>
      <StackWrapperContent {...props} />
    </Container>
  );
};

SalifyStackWrapper.displayName = "SalifyStackWrapper";

export default SalifyStackWrapper;

const StackWrapperContent: FC<SalifyStackWrapperProps> = (props) => {
  return (
    <Stack
      alignItems={props.stackProps?.alignItems || "stretch"}
      direction={props.direction}
      spacing={props.stackProps?.spacing ?? { mobile: 2, tablet: 3, laptop: 4 }}
      {...props.stackProps}
    >
      {props.components && !!props.components.length && (
        <SalifyComponent components={props.components} />
      )}
    </Stack>
  );
};
